export interface UserEditLogChange {
  field: string;
  /** Valor anterior. Sempre null em campos sensíveis (senha, credenciais Twilio, 2FA). */
  old: any;
  /** Valor novo. Sempre null em campos sensíveis. */
  new: any;
}

export interface UserEditLog {
  id: string;
  user_id: string;
  /** null quando a alteração partiu do próprio sistema (job/comando), sem usuário logado. */
  editor_id: string | null;
  editor_name: string | null;
  editor_email: string | null;
  /** Coluna `changed_fields` no backend — `changes` colidiria com o Eloquent. */
  changed_fields: UserEditLogChange[];
  ip: string | null;
  created_at: string;
}

/**
 * Campos cujo valor o backend nunca grava na trilha — só o fato de terem
 * mudado. Espelho de SENSITIVE_FIELDS em App\Observers\UserObserver.
 *
 * O backend também mascara colunas que não estão na lista dele (`$hidden`,
 * casts `encrypted*`), então este espelho sempre pode ficar para trás. Por isso
 * a tela não depende só dele: ver UserEditLogsComponent::isMasked().
 */
export const USER_EDIT_LOG_MASKED_FIELDS = [
  'password',
  'account_sid',
  'auth_token',
  'twilio_phone',
  'partner_webhook_secret',
  'two_factor_secret',
  'two_factor_recovery_codes',
  'two_factor_last_timestep',
  'api_token',
];

/**
 * Campos sintéticos: não são colunas de `users`, são EVENTOS da conta — não há
 * "de → para" a mostrar. Ver as constantes AFFILIATE_* e ACCOUNT_* em
 * App\Observers\UserObserver.
 *
 *   - affiliate_added/removed trazem o afilhado ("Nome <email>") em `new` ou
 *     em `old`, respectivamente;
 *   - account_deleted/restored chegam com os dois nulos: o rótulo já diz tudo.
 */
export const USER_EDIT_LOG_EVENT_FIELDS = [
  'affiliate_added',
  'affiliate_removed',
  'account_deleted',
  'account_restored',
];
